// The myUMBC search box owns the input now (see #search-box); the Google CSE
// is results-only. On load, run the full Google search for the current query
// so the results render without a Google-owned input box.
// window.__gcse || (window.__gcse = {});
// window.__gcse.initializationCallback = function () {
//   var container = document.getElementById("search");
//   var query = container?.dataset?.query;
//   if (!query) return;

//   var searchElement = window.google?.search?.cse?.element?.getElement("myumbc-searchresults");
//   if (searchElement) searchElement.execute(query);
// };


// Adds a callback to toggle the "first page" class on #search when the Google CSE renders results.
// The class can be used to show/hide sections that should only appear on the first page of results
// (e.g. the Resources list).
function toggleFirstPageClass() {
  var container = document.getElementById("search");
  var query = container?.dataset?.query;
  if (!query) return;

  var hash = new URLSearchParams(window.location.hash.slice(1));
  var page = parseInt(hash.get("gsc.page"), 10);

  if (!page || page < 1) return;

  if (page > 1) {
    container.classList.remove("search__first-page");
  } else {
    container.classList.add("search__first-page");
  }
}
window.__gcse || (window.__gcse = {});
window.__gcse.searchCallbacks || (window.__gcse.searchCallbacks = {});
window.__gcse.searchCallbacks.web || (window.__gcse.searchCallbacks.web = {});
// window.__gcse.searchCallbacks.web.rendered = toggleFirstPageClass;


// Formats an event's date range for the injected meta line. Examples:
//   all day, single date : "Apr 2, 2026 (All Day)"
//   single date + times  : "Apr 2, 2026 · 1:00 – 4:00 PM"
//   spans dates          : "Apr 2, 2026 1:00 PM – Apr 3, 2026 4:00 PM"
// Uses a short "Apr 2, 2026" date and a "1:00 PM" time with no leading zero, so
// the line reads like a person wrote it rather than a machine timestamp.
function formatEventDate(date) {
  return date.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' });
}

function formatEventTime(date) {
  return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

function formatEventDates(startDate, endDate) {
  if (!startDate || !endDate) return '';
  const startDateStr = formatEventDate(startDate);
  const endDateStr = formatEventDate(endDate);
  const startTimeStr = formatEventTime(startDate);
  const endTimeStr = formatEventTime(endDate);

  if (startDateStr === endDateStr) {
    if (startTimeStr === '12:00 AM' && endTimeStr === '11:59 PM') {
      return `${startDateStr} (All Day)`;
    }
    return `${startDateStr} · ${startTimeStr} – ${endTimeStr}`;
  }
  return `${startDateStr} ${startTimeStr} – ${endDateStr} ${endTimeStr}`;
}

// A short "how soon" label for an upcoming event ("Today", "Tomorrow",
// "in 3 days", "in 2 weeks"), or null for events that have already ended. Based
// on the calendar-day difference from today so "Tomorrow" reads correctly
// regardless of the time of day.
function relativeEventLabel(startDate, endDate) {
  const now = new Date();
  if (endDate < now) return null; // already over — no "soon" label

  const startOfDay = d => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const days = Math.round((startOfDay(startDate) - startOfDay(now)) / 86400000);

  if (days <= 0) return 'Today';
  if (days === 1) return 'Tomorrow';
  if (days < 7) return `in ${days} days`;
  if (days < 14) return 'in 1 week';
  if (days < 30) return `in ${Math.round(days / 7)} weeks`;
  return null; // far out — the date itself is enough
}

const makeMetadataCallback = () => {
  let saveForRenderCallback;
  const readyCallback = (name, q, promos, results, resultsDiv) =>
  {
    saveForRenderCallback = [];
    for (const result of results) {
      const {
        richSnippet: {
          event = {},
          place = {},
        } = {},
      } = result;
      if (event) {
        const startDate = event.startdate;
        const endDate = event.enddate;
        let obj = {};
        // We want to hide breadcrumbs for myUMBC Events
        if (result.visibleUrl === "my3.my.umbc.edu" || result.visibleUrl === "my.umbc.edu") {
          obj.hideBreadcrumbs = true;
        }
        if (place && place.name) obj.placeName = place.name;
        if (startDate) obj.startdate = new Date(startDate.slice(0, -6)); // Remove timezone offset for consistent parsing
        if (endDate) obj.enddate = new Date(endDate.slice(0, -6)); // Remove timezone offset for consistent parsing
        saveForRenderCallback.push(obj);
      }
    }
  };
  const renderedCallback = (name, q, promos, results) => {
    for (let i = 0; i < results.length; ++i) {
      const div = results[i];
      const result = saveForRenderCallback[i];
      if (!result) continue;

      const startDate = result['startdate'];
      const endDate = result['enddate'];
      const hideBreadcrumbs = result['hideBreadcrumbs'];
      const placeName = result['placeName'];
      if (hideBreadcrumbs) {
        const breadcrumbs = div.querySelector('.gsc-url-top');
        if (breadcrumbs) {
          breadcrumbs.style.display = 'none';
        }
      }
      if (startDate && endDate) {
        const innerDiv = document.createElement('div');
        innerDiv.className = 'search-event-meta';

        const isPast = endDate < new Date();
        // Past events are visually demoted (see _main.scss) and tagged, so a
        // years-old event doesn't read as current when Google ranks it high.
        // Upcoming events get a "how soon" lead ("Tomorrow", "in 3 days") so
        // imminence is obvious at a glance.
        if (isPast) {
          div.querySelector('.gsc-table-result')?.classList.add('search-event--past');
        }

        // Build the row as discrete flex items (see .search-event-meta), each a
        // sub-element so they align on a shared center line regardless of the
        // pill's padding — rather than an inline string where the padded tag
        // wouldn't line up. Dot separators are their own items; flex gap spaces
        // everything evenly.
        const part = (tag, className, text) => {
          const el = document.createElement(tag);
          if (className) el.className = className;
          el.textContent = text;
          return el;
        };
        const parts = [];
        const relative = relativeEventLabel(startDate, endDate);
        if (relative) parts.push(part('span', 'search-event-meta__soon', relative));
        parts.push(part('b', 'search-event-meta__date', formatEventDates(startDate, endDate)));
        if (placeName) parts.push(part('span', 'search-event-meta__place', placeName));
        if (isPast) parts.push(part('span', 'search-event-meta__past-tag', 'Past event'));

        parts.forEach((el, idx) => {
          // A "·" separator before every item except the first and the past tag
          // (the tag reads as a standalone chip, not a dotted continuation).
          if (idx > 0 && !el.classList.contains('search-event-meta__past-tag')) {
            innerDiv.appendChild(part('span', 'search-event-meta__sep', '·'));
          }
          innerDiv.appendChild(el);
        });
        div.querySelector('.gsc-table-result').insertAdjacentElement('afterbegin', innerDiv);

        // Google prefixes an event snippet with its own date + " ... " (e.g.
        // "Apr 29, 2021 ... There is no pre-registration…"), which just repeats
        // the date line we injected above. Drop that leading date so the snippet
        // starts on the actual description. Only done here — where we injected a
        // date — so non-event snippets keep any meaningful leading date.
        const snippet = div.querySelector('.gs-snippet');
        if (snippet) {
          // Leading "Mon D, YYYY" (year optional) followed by the ellipsis Google
          // renders as a "..." run; strip through it and its surrounding spaces.
          snippet.innerHTML = snippet.innerHTML.replace(
            /^\s*[A-Z][a-z]{2}\s+\d{1,2}(?:,\s*\d{4})?\s*(?:\.\.\.|<b[^>]*>\s*\.\.\.\s*<\/b>|…)\s*/,
            ''
          );
        }
      }
    }
  };
  return {readyCallback, renderedCallback};
};
const {
  readyCallback: webResultsReadyCallback,
  renderedCallback: webResultsRenderedCallback,
} = makeMetadataCallback();
window.__gcse.searchCallbacks = {
  web: {
    ready: webResultsReadyCallback,
    rendered: (name, q, promos, results) => {
      webResultsRenderedCallback(name, q, promos, results);
      toggleFirstPageClass();
    },
  },
};


// Run the toggle on load to help reduce blinking when the page is loaded with
// a hash that indicates a non-first page of results.
(function() {
  toggleFirstPageClass();
})();

// Index suggestions as you type — mirrors the header UI search box. Suggestions
// come from the local index (/search/suggest); the full Google results
// only load on submit (Enter or the arrow button), which navigates to /search.

// var refinementsToggleContainer = document.getElementById("refinements");

// (function() {
//   refinementsToggleContainer?.addEventListener("click", function(evt) {
//     var link = evt.target.closest("a[data-refinement]");
//     if (!link) return;
//     evt.preventDefault();
//     var container = document.getElementById("search");
//     if (!container) return;
//     var currentRefinement = container.dataset.refinement;
//     var selectedRefinement = link.dataset.refinement;
//     // if (currentRefinement === selectedRefinement) return;
//     var element = window.google?.search?.cse?.element?.getElement("myumbc-searchresults");
//     if (!element) return;
//     var hash = new URLSearchParams(window.location.hash.slice(1));
//     if (selectedRefinement === "all") {
//       hash.delete("gsc.ref");
//     } else {
//       hash.set("gsc.ref", 'more:' + selectedRefinement);
//     }
//     container.dataset.refinement = selectedRefinement;
//     history.replaceState(null, null, '#' + hash.toString());
//     var query = element.getInputQuery();
//     // var cleanQuery = element.getInputQuery()?.replace(/\bmore:\S+/g, '')?.trim();
//     // if (!cleanQuery) return;
//     // var newQuery = cleanQuery + ' more:' + selectedRefinement;
//     // element.clearAllResults();
//     // element.execute(query);
//   });
// })();

document.addEventListener("DOMContentLoaded", function () {
  var form = document.getElementById("search-box");
  if (!form) return;
  var input = form.querySelector(".search-box__input");
  var clear = form.querySelector(".search-box__clear");
  var results = form.querySelector(".search-box__suggestions");
  var suggestUrl = form.dataset.suggestUrl;
  var DEBOUNCE_MS = 180;

  if (!suggestUrl) return;

  var debounce = null;
  var xhr = null;
  var cache = {};

  function currentQuery() { return input.value.replace(/\s+/g, " ").trim(); }

  function suggestionLinks() { return Array.prototype.slice.call(results.querySelectorAll(".menu__item")); }

  function showSuggestions(html, forQuery) {
    if (currentQuery() !== forQuery) return; // stale render, query moved on
    results.innerHTML = html;
  }

  // Close the dropdown without clearing the query — drops any pending request
  // and empties the list (the :empty rule hides it). Reopens on next input.
  function closeSuggestions() {
    cancel();
    results.innerHTML = "";
  }

  // Move selection by focusing items — same as the header UI search box, so the
  // highlight is the shared .menu__item:focus style. Down from the input focuses
  // the first item; Up from the first item returns to the input. Enter then
  // follows the focused link natively (no full search).
  function moveSelection(direction) {
    var links = suggestionLinks();
    if (links.length === 0) return;
    var current = links.indexOf(document.activeElement);
    var next = current + direction;
    if (next < 0) {
      input.focus();
    } else if (next < links.length) {
      links[next].focus();
    } else {
      links[links.length - 1].focus();
    }
  }

  function cancel() {
    clearTimeout(debounce);
    debounce = null;
    if (xhr) { xhr.abort(); xhr = null; }
  }

  function load() {
    var query = currentQuery();
    if (query === "") return;

    var cached = cache[query];
    if (cached != null) { showSuggestions(cached, query); return; }

    if (xhr) xhr.abort();
    var request = new XMLHttpRequest();
    xhr = request;
    request.open("GET", suggestUrl + "?" + new URLSearchParams({ query: query }));
    request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    request.onload = function () {
      // Only trust a non-empty 200. A blank body (server hiccup, truncated or
      // aborted-but-still-resolved response) must NOT be cached: the input
      // handler's cache fast-path would then re-serve "" for every future
      // keystroke landing on this query — hiding the dropdown with no network
      // request until reload. Treat blank as "no answer", not a cached empty.
      if (request.status === 200 && request.responseText.trim() !== "") {
        cache[query] = request.responseText;
        showSuggestions(request.responseText, query);
      }
      if (xhr === request) xhr = null;
    };
    request.send();
  }

  form.classList.toggle("search-box--query", currentQuery() !== "");

  input.addEventListener("input", function () {
    form.classList.toggle("search-box--query", currentQuery() !== "");
    if (currentQuery() === "") { cancel(); results.innerHTML = ""; return; }
    if (cache[currentQuery()] != null) { cancel(); load(); return; }
    clearTimeout(debounce);
    debounce = setTimeout(load, DEBOUNCE_MS);
  });

  // Arrow keys move focus through suggestions; Enter then follows the focused
  // link (full search only happens when focus is in the input). Listen on the
  // form so the handler keeps firing once focus moves off the input.
  form.addEventListener("keydown", function (evt) {
    if (evt.key === "ArrowDown") {
      if (suggestionLinks().length === 0) return;
      evt.preventDefault();
      moveSelection(1);
    } else if (evt.key === "ArrowUp") {
      if (suggestionLinks().length === 0) return;
      evt.preventDefault();
      moveSelection(-1);
    } else if (evt.key === "Escape") {
      closeSuggestions();
      input.focus();
    }
  });

  // Clicking outside the search box closes the dropdown (keeps the query).
  document.addEventListener("click", function (evt) {
    if (!form.contains(evt.target)) closeSuggestions();
  });

  clear.addEventListener("click", function () {
    input.value = "";
    closeSuggestions();
    form.classList.remove("search-box--query");
    input.focus();
  });
});

// Handle toggling of the "Show Search Answers" preference. The card collapses
// immediately (optimistic UI) while the preference saves in the background;
// on failure it reverts so the toggle doesn't drift from the saved value.
document.addEventListener("DOMContentLoaded", function () {
  var cardEl = document.getElementById("search-answer-card");
  if (!cardEl) return;
  function handlePreferenceToggle(evt) {
    var toggle = evt.target.closest(".toggle-switch") || (evt.target.classList.contains("search-answer-preference-checkbox") ? evt.target.closest(".search-answer-preference-label").querySelector(".toggle-switch") : null);
    if (!toggle) return;
    if (toggle.classList.contains("toggle-switch--processing")) return;
    toggle.classList.add("toggle-switch--processing");
    var currentlyEnabled = !cardEl.classList.contains("search-answer-card--collapsed");
    cardEl.classList.toggle("search-answer-card--collapsed", currentlyEnabled);
    var form = cardEl.querySelector("#search-answer-preference-form");
    var xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    var csrfToken = document.querySelector("meta[name=csrf-token]");
    if (csrfToken) xhr.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
    xhr.onload = function () {
      if (xhr.status !== 200) {
        cardEl.classList.toggle("search-answer-card--collapsed", !currentlyEnabled);
      } else if (!currentlyEnabled && window.__searchLoadAnswerOnEnable) {
        // Wait for the preference save to land before fetching — the answer
        // endpoint re-checks the live preference server-side, so fetching in
        // parallel with the save can race and see the stale (off) value.
        window.__searchLoadAnswerOnEnable();
      }
      toggle.classList.remove("toggle-switch--processing");
    };
    xhr.onerror = function () {
      cardEl.classList.toggle("search-answer-card--collapsed", !currentlyEnabled);
      toggle.classList.remove("toggle-switch--processing");
    };
    xhr.send("opt_in=" + (currentlyEnabled ? "0" : "1"));
  }
  cardEl.querySelector(".search-answer-card__header").addEventListener("click", handlePreferenceToggle);
  cardEl.querySelector(".search-answer-card__header").addEventListener("change", handlePreferenceToggle);
});

// Show more for the search resources list — only show the first 6 by default, then
// reveal the rest when the user clicks "Show All".
document.addEventListener("DOMContentLoaded", function () {
  var searchResources = document.getElementById("search-resources");
  if (!searchResources) return;

  var moreResources = searchResources.querySelector(".resources-show-more");
  if (moreResources) {
    moreResources.addEventListener("click", function () {
      searchResources.classList.remove("search-resources--truncated");
      moreResources.setAttribute("aria-expanded", "true");
      moreResources.style.display = "none";
    });
  }
});

// Load the answer asynchronously — either after the page loads (so the Google
// CSE can render results without waiting for it) or when the user flips
// answers on for a query that was already answerable but not yet fetched
// (see the preference-toggle handler above). Also handles rating feedback and
// expanding the answer text if it's truncated.
(function () {
  var loadStarted = false;

  function loadAnswer() {
    if (loadStarted) return;
    var container = document.getElementById("search");
    var answer_container = document.getElementById("search-answer");
    var query = container?.dataset?.query;
    if (!container || !query || !answer_container) return;
    loadStarted = true;

    var titleEl = document.querySelector(".search-answer-card__title");
    if (titleEl) {
      var pawIcon = document.querySelector(".search-answer-loading .icon--loading-paw") || document.querySelector(".icon--loading-paw");
      titleEl.innerHTML = "";
      if (pawIcon) titleEl.appendChild(pawIcon.cloneNode(true));
      titleEl.appendChild(document.createTextNode("Fetching answer…"));
    }

    var url = answer_container.dataset.url + "?query=" + encodeURIComponent(query);
    var FADE_MS = 120;
    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) {
        if (!r.ok) throw new Error("Search answer request failed: " + r.status);
        return r.text();
      })
      .then(function (html) {
        // Cross-fade: fade the skeleton out, then swap in the real answer and
        // fade it in, rather than an instant content swap.
        answer_container.classList.add("search-answer-container--fading");
        return new Promise(function (resolve) {
          setTimeout(function () { resolve(html); }, FADE_MS);
        });
      })
      .then(function (html) {
        answer_container.innerHTML = html;
        answer_container.classList.remove("search-answer-container--fading");
        answer_container.classList.add("search-answer-container--loaded");
        var answer = answer_container.querySelector(".ai-answer");
        var empty = answer_container.querySelector(".ai-answer-empty");
        if (titleEl) titleEl.textContent = (answer && answer.dataset.question) || (empty && empty.dataset.question) || "Answer";
        var text = answer && answer.querySelector(".answer-text");
        if (answer && text) {
          // Only keep the truncated state (and the "Show more" button) when
          // there's at least ~2 lines of genuinely hidden content. The mask
          // fade already previews the bottom half of the truncated box, so
          // a smaller overage reveals almost nothing when expanded and reads
          // as if the button did nothing.
          var lineHeight = parseFloat(getComputedStyle(text).lineHeight) || 1;
          var MIN_HIDDEN_LINES = 2;
          var hiddenHeight = text.scrollHeight - text.clientHeight;
          if (hiddenHeight < lineHeight * MIN_HIDDEN_LINES) {
            answer.classList.remove("ai-answer--truncated");
          }
        }
        var readMore = answer && answer.querySelector(".answer-read-more");
        if (readMore) {
          readMore.addEventListener("click", function () {
            answer.classList.remove("ai-answer--truncated");
            readMore.setAttribute("aria-expanded", "true");
            readMore.style.display = "none";
          });
        }
        if (answer) {
          answer.addEventListener("click", function (evt) {
            var link = evt.target.closest(".answer-feedback__link--rate");
            if (!link || link.classList.contains("answer-feedback__link--clicked")) return;
            evt.preventDefault();
            link.classList.add("answer-feedback__link--clicked");
            var url = link.dataset.url;
            if (!url) return;
            var showNoReasons = link.dataset.showNoReasons !== undefined;
            var xhr = new XMLHttpRequest();
            xhr.open("POST", url);
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            var csrfToken = document.querySelector("meta[name=csrf-token]");
            if (csrfToken) xhr.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
            xhr.onload = function () {
              if (xhr.status === 200) {
                answer.classList.remove("search--feedback-no-reasons");
                answer.classList.add(showNoReasons ? "search--feedback-no-reasons" : "search--feedback-completed");
              }
            };
            xhr.send();
          });
        }
      })
      .catch(function () {
        // Answer wasn't available after all (e.g. the preference was turned
        // off in another tab while this fetch was in flight) — drop back to
        // the pre-fetch title and clear loadStarted so a later retrigger
        // (e.g. re-enabling the preference) can try again.
        loadStarted = false;
        answer_container.classList.remove("search-answer-container--fading");
        answer_container.innerHTML = "";
        if (titleEl) titleEl.textContent = "Answer";
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    var cardEl = document.getElementById("search-answer-card");
    // Skip the eager load if the card starts collapsed (answers off) — the
    // server would reject the fetch anyway (see My4::SearchController#answer),
    // since it re-checks the preference at fetch time. loadAnswerOnEnable,
    // set on window by the toggle handler above, runs it once the user turns
    // answers on instead.
    if (cardEl && cardEl.classList.contains("search-answer-card--collapsed")) return;
    loadAnswer();
  });

  window.__searchLoadAnswerOnEnable = loadAnswer;
})();

// Click tracking for the Google CSE results — those links are rendered by
// Google's own JS after the page loads, replacing our .gcse-searchresults-only
// placeholder with its own gsc-*/gs-* markup, so we can't attach a [data-track]
// attribute to each result server-side (see tracking.js for that generic path).
// The signed message instead lives on the stable #search container as
// data-results-track — a distinct attribute from tracking.js's [data-track] so
// its generic handler doesn't also match every click inside #search (that would
// resolve the "link" as #search itself and log the whole page as the label).
// This listener resolves url/label from whichever Google result link was
// actually clicked, mirroring tracking.js's beacon shape. Unlike a suggestion
// click, no separate Search.query beacon is needed here — the query was
// already logged server-side when My4::SearchController#index rendered this
// page, so firing another would double-count the search.
document.addEventListener("click", function (evt) {
  var container = evt.target.closest("#search[data-results-track]");
  if (!container) return;
  var resultsArea = evt.target.closest(".gsc-control-cse");
  if (!resultsArea) return;
  var link = evt.target.closest("a[href]");
  if (!link) return;

  var params = new URLSearchParams();
  params.set("from", window.location.pathname);

  // The "Search '<query>' on Google" link below pagination carries the raw
  // query and CSE config in its URL (google.com/search?q=...&cx=...), which
  // is different on every search and useless for grouping. Log it as one
  // fixed target instead of the literal URL.
  if (evt.target.closest(".gcsc-more-maybe-branding-root")) {
    params.set("url", "https://www.google.com/search");
    params.set("label", "Search on Google");
  } else {
    try {
      var url = new URL(link.getAttribute("href"), window.location.href);
      // Always the full origin + path (never scheme-relative), so the
      // logged url is complete whether it's on this origin, another UMBC
      // subdomain, or an external site.
      params.set("url", url.origin + url.pathname + url.search);
    } catch {
      params.set("url", link.getAttribute("href"));
    }

    var label = (link.textContent || "").replace(/\s+/g, " ").trim();
    if (label) params.set("label", label);
  }

  navigator.sendBeacon("/_action/" + encodeURIComponent(container.dataset.resultsTrack) + "?" + params);
}, true);